import { render, staticRenderFns } from "./paymenttransation.vue?vue&type=template&id=a58fb65c&"
import script from "./paymenttransation.vue?vue&type=script&lang=js&"
export * from "./paymenttransation.vue?vue&type=script&lang=js&"
import style0 from "./paymenttransation.vue?vue&type=style&index=0&id=a58fb65c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports